var English = "อังกฤษ";
var French = "ฝรั่งเศส";
var German = "เยอรมัน";
var Italian = "อิตาลี";
var Japanese = "ญี่ปุ่น";
var Korean = "เกาหลี";
var Portuguese = "โปรตุเกส";
var Russian = "รัสเซีย";
var Spanish = "สเปน";
var Bahasa = "บาฮาซา";
var Thai = "ไทย";
var Vietnamese = "Vietnamese";
var Turkish = "Turkish";
var Arabic = "อารบิก";
var languagePreference = {
	English: English,
	French: French,
	German: German,
	Italian: Italian,
	Japanese: Japanese,
	Korean: Korean,
	Portuguese: Portuguese,
	Russian: Russian,
	"Chinese-Simplified": "จีนตัวย่อ",
	"Chinese-Traditional": "จีนตัวเต็ม",
	Spanish: Spanish,
	Bahasa: Bahasa,
	Thai: Thai,
	Vietnamese: Vietnamese,
	Turkish: Turkish,
	Arabic: Arabic
};

export { Arabic, Bahasa, English, French, German, Italian, Japanese, Korean, Portuguese, Russian, Spanish, Thai, Turkish, Vietnamese, languagePreference as default };
